import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
const guarantees = ['Download Istantaneo', 'Nessun Abbonamento', 'Accesso a Vita', 'Garanzia di 7 Giorni'];
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section className="w-full bg-cream px-5 pb-20 pt-5" data-id="element-109" data-mp="4lql31pohn65">
      <div className="mx-auto max-w-4xl text-center" data-id="element-110" data-mp="4na0kq3ifu6v">
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="font-display text-[2.5rem] font-black leading-[1.02] tracking-tight text-ink sm:text-6xl md:text-[4.2rem]" data-id="element-111" data-mp="12a0mpfljy8wq">
          Risolvi un Intero Anno di Lezioni di Scienze in soli{' '}
          <span className="italic text-brand" data-id="element-112" data-mp="neav91xll3km">5 Minuti</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: EASE
      }} className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink/60 sm:text-lg" data-id="element-113" data-mp="3d33d6tuq0lin">
          Unisciti a oltre 1.500 insegnanti che hanno smesso di improvvisare.
          Entra in classe con tutto pronto per spiegare, sperimentare e
          ispirare.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.16,
        ease: EASE
      }} className="mx-auto mt-2 max-w-2xl pb-5 pt-2.5 sm:mt-8" data-id="element-114" data-mp="3e8mtl1bhqrfo">
          <img src="https://cdn.magicpatterns.com/uploads/nAb4hSFX69BSJuoxFeR4p5/8ef8c362-c1c1-4fef-9a97-c5606e82ac05.webp" alt="Il pacchetto SCIENZE PRONTA: gli otto volumi dalla 1ª Primaria alla 3ª Media con il Kit Laboratorio, la piattaforma digitale su desktop, tablet e smartphone e i 5 bonus inclusi" className="mx-auto w-[70%] max-w-sm sm:w-[66%]" data-id="element-115" data-mp="35audvw1uxhrr" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.24,
        ease: EASE
      }} className="-mt-2 sm:mt-8" data-id="element-116" data-mp="s1rqcip57wrn">
          <CtaButton href="#offer" data-id="element-117" data-mp="ibowkga76es9" />
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-xs font-semibold text-ink/50 sm:text-sm" data-id="element-118" data-mp="icrn2n3lyf7n">
            {guarantees.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-119" data-mp="1azkutpff0er5" data-mpi={index}>
                <span data-id="element-120" data-mp="161ay3ae1l63f">{item}</span>
                {index < guarantees.length - 1 && <span aria-hidden="true" className="text-ink/25" data-id="element-121" data-mp="112g55fmd215l">
                    ·
                  </span>}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}